import { updateTimeSlots } from "./updateTimeSlots";

export function availableButtonClickEvent() {
  let availableDates = document.querySelectorAll('.available');
  availableDates.forEach((a) => {
    a.addEventListener('click', addButtonfunctionality);
  })
}

// hate the name of this function, but it's what it does.
function addButtonfunctionality() {
  console.log('add button functionality')
  let availableDates = document.querySelectorAll('.available');
  availableDates.forEach((a) => {
    a.classList.remove('selected');
  })

  this.classList.add('selected');
  let dateInput = document.querySelector('input[name="date"]');
  let date = this.id;
  dateInput.value = date;

  let appointmentDisplayDate = document.querySelectorAll('#appointmentDisplayDate');
  appointmentDisplayDate.forEach((appointmentDisplayDate) => {
    appointmentDisplayDate.innerHTML = date;
  });

  updateTimeSlots();
}
